<template>
  <div class="l-container h-full confirm-info mx-auto">
    <div class="top-title ml-2">
      <h3>お申し込みキャンセル（申請完了）</h3>
    </div>
    <div class="mt-3 mb-3 divider border"></div>
    <div class="main-content flex">
      <div class="left-content m-4 ml-0">
        <LeftMenuBar v-bind:nav-bars="navBars" />
      </div>
      <div class="right-content">
        <BackToPrevious />
        <div class="c-box mx-4 mr-0">
          <div class="text-center title-cancel">
            <span class="font-bold">お申し込みをキャンセルしました</span>
          </div>
          <div class="text-center content-cancel">
            <span class="mr-8">受付No.{{ acptNo }}</span>
            <span>キャンセル番号: {{getCancelNo}}</span>
          </div>
        </div>
        <BackToPrevious />
      </div>
    </div>
  </div>
</template>

<script>
import { LeftMenuBar } from '@/components/compound'
import _ from 'lodash'
import BackToPrevious from './components/BackToPrevious'

export default {
  name: 'BS_MYP_05_043',
  components: {
    BackToPrevious,
    LeftMenuBar
  },
  data() {
    return {
      acptNo: '',
      navBars: [
        { path: '/mypage', name: 'マイページトップ' },
        { type: 'divider' },
        { path: '/mypage/benepo-history', name: '総保有ベネポ・ベネポ履歴' },
        { path: '/mypage/benepo-collect', name: '獲得予定のベネポ' },
        { type: 'divider' },
        { path: '/mypage/coupons', name: '専用ポイント・補助クーポン' },
        { type: 'divider' },
        { path: 'bs-myp-02-001', name: 'マイクーポン' },
        { path: 'bs-myp-02-010', name: '過去のクーポン' },
        { type: 'divider' },
        { path: '/mypage/orders', name: 'お申し込み履歴' },
        { path: '', name: '給トク払いご利用履歴', icon: 'icon-bor-copy' },
        { type: 'divider' },
        { path: '/mypage/visits', name: '閲覧履歴' },
        { type: 'divider' },
        { path: '/mypage/favorites', name: 'お気に入りメニュー' },
        { type: 'divider' },
        { path: '/mypage/setting', name: '会員プロフィール', icon: 'icon-bor-copy' },
        { path: '', name: 'メール受信・通知', icon: 'icon-bor-copy' },
        { path: '', name: 'クレジットカード', icon: 'icon-bor-copy' },
        { type: 'divider' },
        { path: '', name: '家族アカウント管理', icon: 'icon-bor-copy' },
        { type: 'divider' },
        { path: '', name: 'ログアウト', icon: 'icon icon-bor-logout' }
      ],
      breadcrumb_data: [
        'トップ',
        'マイページ',
        'お申し込み一覧',
        'お申し込み情報詳細',
        'お申し込みキャンセル（申請完了）'
      ]
    }
  },
  computed: {
    loggedIn() {
      return this.$auth.loggedIn
    },
    getCancelNo() {
      return _.cloneDeep(_.get(this.$store.state, 'order_old.cancelNo', null))
    }
  },
  mounted() {
    if (this.loggedIn) {
      this.acptNo = this.$route.query.acptNo
    } else {
      const params = {
        loggin: 1
      }
      this.$router.push({path: '/', query: params})
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
.nav {
  width: 100%;
}
</style>
